import React from 'react';
// import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// import classesModule from './Tabs.module.scss';
import { IsDesktopHandler } from 'helpers';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	tabsStyle: {
		borderBottomColor: theme.palette.divider,
		borderBottom: '1px solid',
	},
}));

const SimpleTabs = (props) => {
	const classes = useStyles();

	const tabList = props.tabitems.map((tKey, tid) => {
		return (
			<Tab
				key={tid}
				classes={
					{
						// root: classes.rootTabs,
						// selected: classes.TabsSelected,
						// textColorPrimary: classes.TabsTextColor,
					}
				}
				disabled={props.tabsDisabled || false}
				label={tKey}
				{...a11yProps({ tid })}
			/>
		);
	});

	const isDesktop = IsDesktopHandler('md');

	// console.log(isDesktop, '<-----isDesktop');

	return (
		<div className={classes.root}>
			<Box
				elevation={2}
				component="div"
				// style={{ borderBottom: '1px solid' }}
			>
				<Tabs
					value={props.value}
					onChange={props.toggler}
					indicatorColor="secondary"
					className={classes.tabsStyle}
					textColor="secondary"
					aria-label="area de Tabs"
					variant="scrollable"
					scrollButtons={isDesktop ? 'auto' : true}
				>
					{}
					{tabList}
				</Tabs>
			</Box>
			{props.children}
		</div>
	);
};

export default SimpleTabs;
